"use strict";

/**
 * Stores app version in window
 * @param {string} appName
 * @param {object} version
 * @returns {string}
 */
var setAppVersion = function (_, e) {
  "undefined" != typeof window && (/* eslint-disable no-underscore-dangle */
  window.__APPS__ = window.__APPS__ || {}, window.__APPS__[_] = e);
};
module.exports = setAppVersion;